<template>
    <div>
        <!-- Delete Modal -->
        <b-modal
            id="delete_confirmation_modal"
            title="Delete Member"
            size="sm"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <div>
                <b-row>
                    <b-col>
                        <h1>Are you sure?</h1>
                        <p>
                            You are about to remove '{{
                                delete_confirmation_modal.member.name
                            }}' as an organization member.
                        </p>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col class="text-right">
                        <base-button
                            type="danger"
                            :pill="true"
                            class="my-4 btn-success"
                            :disabled="delete_confirmation_modal.loading"
                            @click="delete_confirmation_modal_delete()"
                            :loading="delete_confirmation_modal.loading"
                            :success="delete_confirmation_modal.success"
                            >Confirm
                        </base-button>
                        <base-button
                            type="success"
                            :pill="true"
                            class="my-4 btn-success"
                            @click="$bvModal.hide('delete_confirmation_modal')"
                            :disabled="delete_confirmation_modal.loading"
                            >Close
                        </base-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <!-- C Modal -->
        <b-modal
            id="c_modal"
            title="Invite Organization Member"
            size="md"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <div>
                <b-row>
                    <b-col>
                        <validation-observer
                            v-slot="{ handleSubmit }"
                            ref="formValidator"
                        >
                            <b-form
                                role="form"
                                @submit.prevent="
                                    handleSubmit(c_modal_invite_member)
                                "
                            >
                                <input
                                    type="submit"
                                    ref="c_modal_form_submit_button"
                                    hidden
                                />
                                <b-row>
                                    <b-col>
                                        <base-input
                                            :pill="true"
                                            label="Email Address"
                                            class="mb-3"
                                            name="Email Address"
                                            :rules="{
                                                required: true,
                                                email: true,
                                            }"
                                            placeholder="Email of the member to be invited"
                                            v-model="c_modal.form.email"
                                            :disabled="c_modal.loading"
                                        >
                                        </base-input>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </validation-observer>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col class="text-right">
                        <base-button
                            type="danger"
                            :pill="true"
                            class="my-4 btn-success"
                            @click="$bvModal.hide('c_modal')"
                            :disabled="c_modal.loading"
                            >Close
                        </base-button>
                        <base-button
                            type="success"
                            :pill="true"
                            class="my-4 btn-success"
                            @click="$refs.c_modal_form_submit_button.click()"
                            :disabled="c_modal.loading"
                            :loading="c_modal.loading"
                            :success="c_modal.success"
                            >Invite
                        </base-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <b-card no-body>
            <b-card-header>
                <b-row>
                    <b-col cols="6">
                        <h1 class="mb-0">Organization Members</h1>
                    </b-col>
                    <b-col cols="6" class="text-right">
                        <el-tooltip content="Add" placement="top">
                            <base-button
                                v-if="
                                    is_organization_admin ||
                                    is_organization_owner
                                "
                                type="primary"
                                round
                                icon
                                size="sm"
                                @click="$bvModal.show('c_modal')"
                            >
                                <span class="btn-inner"
                                    ><i class="fa fa-plus"></i
                                ></span>
                            </base-button>
                        </el-tooltip>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body>
                <div v-if="$apollo.loading && table_data.length == 0">
                    <b-row
                        class="mt-2 d-flex align-items-center justify-content-center"
                    >
                        <b-col
                            class="d-flex align-items-center justify-content-center"
                        >
                            <Transition>
                                <h1>
                                    <i class="fas fa-spinner fa-spin ml-1"></i>
                                </h1>
                            </Transition>
                        </b-col>
                    </b-row>
                </div>
                <b-row v-else>
                    <b-col>
                        <el-table
                            class="table-responsive align-items-center table-flush no-lines"
                            header-row-class-name="thead-light"
                            row-class-name="table-rows"
                            :data="table_data"
                            :empty-text="`No organization members yet, use the \'+\' button to invite members.`"
                        >
                            <el-table-column
                                label="Name"
                                min-width="240px"
                                sortable
                            >
                                <template v-slot="{ row }">
                                    <p class="mb-0">{{ row.name }}</p>
                                </template>
                            </el-table-column>

                            <el-table-column
                                label="Role"
                                min-width="240px"
                                sortable
                            >
                                <template v-slot="{ row }">
                                    <p class="mb-0" v-if="row.role == 'ADMIN'">
                                        Admin
                                    </p>
                                    <p class="mb-0" v-if="row.role == 'OWNER'">
                                        Owner
                                    </p>
                                </template>
                            </el-table-column>
                            <el-table-column
                                min-width="180px"
                                align="center"
                                v-if="
                                    is_organization_admin ||
                                    is_organization_owner
                                "
                            >
                                <div slot-scope="{ row }" class="table-actions">
                                    <el-tooltip
                                        content="Remove Membership"
                                        placement="top"
                                    >
                                        <a
                                            href="#!"
                                            @click.prevent="
                                                delete_confirmation_modal_show(
                                                    row
                                                )
                                            "
                                            class="table-action"
                                            data-toggle="tooltip"
                                            data-original-title="Delete Member"
                                            v-if="row.role != 'OWNER'"
                                        >
                                            <i class="fas fa-trash"></i>
                                        </a>
                                    </el-tooltip>
                                </div>
                            </el-table-column>
                        </el-table>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
// Modules
import {
    Table,
    TableColumn,
    DropdownMenu,
    DropdownItem,
    Dropdown,
    Tooltip,
} from "element-ui";

// Queries
import { GET_ORGANIZATION_MEMBERS } from "@/graphql/queries";

// Mutations
import {
    CREATE_ORGANIZATION_MEMBER_INVITE,
    DELETE_ORGANIZATION_MEMBER,
} from "@/graphql/mutations";

export default {
    name: "OrganizationCrudMembersTable",
    components: {
        [Tooltip.name]: Tooltip,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
    },
    props: {
        organization_id: {
            type: String,
            description: "The Id of the organization.",
            default: null,
        },
    },
    apollo: {
        get_organization_members: {
            query: GET_ORGANIZATION_MEMBERS,
            result(res) {
                let flattened = graph_utils.flattened_response(res.data);
                this.table_data = [];
                if (flattened.allOrganizationMember.length > 0) {
                    flattened.allOrganizationMember.forEach((el) => {
                        let table_row = {
                            id: el.id,
                            name: `${el.user__firstName} ${el.user__lastName}`,
                            role: el.role,
                        };

                        this.table_data.push(table_row);
                    });
                }

                if (res.data.organization.userMembershipRole == "admin") {
                    this.is_organization_admin = true;
                    this.is_organization_owner = false;
                } else if (
                    res.data.organization.userMembershipRole == "owner"
                ) {
                    this.is_organization_admin = true;
                    this.is_organization_owner = true;
                }
            },
            error(errors) {
                console.log("Smart Query Error Handler: " + this.$options.name); // Check out https://stackoverflow.com/questions/66782888/how-do-i-consume-errors-in-my-vue-graphql-component-and-let-other-errors-be-hand
                console.log(errors.graphQLErrors);
                return false;
            },
            variables() {
                return {
                    organization_id: this.organization_id,
                };
            },
            update(data) {
                this.apollo_data.get_organization_members = data;
            },
            skip: true,
        },
    },
    data() {
        return {
            apollo_data: {
                get_organization_members: null,
            },
            table_data: [],
            delete_confirmation_modal: {
                loading: false,
                success: false,
                form: {
                    active: false,
                },
                member: {
                    id: null,
                    name: null,
                },
            },
            c_modal: {
                loading: false,
                success: false,
                form: {
                    email: null,
                },
            },
            is_organization_owner: false,
            is_organization_admin: false,
        };
    },
    methods: {
        // Modals

        // delete_confirmation_modal
        delete_confirmation_modal_show(member) {
            this.delete_confirmation_modal.member = member;
            this.$bvModal.show("delete_confirmation_modal");
        },
        delete_confirmation_modal_delete() {
            if (this.delete_confirmation_modal.member.id) {
                this.delete_confirmation_modal.loading = true;

                this.$apollo
                    .mutate({
                        mutation: DELETE_ORGANIZATION_MEMBER,
                        variables: {
                            id: this.delete_confirmation_modal.member.id,
                        },
                    })
                    .then(() => {
                        this.$apollo.queries.get_organization_members.refetch();

                        this.delete_confirmation_modal.loading = false;

                        this.delete_confirmation_modal.success = true;
                        setTimeout(() => {
                            this.delete_confirmation_modal.success = false;
                        }, 1000);
                        setTimeout(() => {
                            this.$bvModal.hide("delete_confirmation_modal");
                        }, 800);
                        this.$notify({
                            message: `Successfully removed: '${this.delete_confirmation_modal.member.name}'' from the organization members.`,
                            timeout: 5000,
                            icon: "ni ni-check-bold",
                            type: "success",
                        });
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$notify({
                            message: `Could not remove: '${this.delete_confirmation_modal.member.name}' from the organization members.`,
                            timeout: 5000,
                            icon: "ni ni-check-bold",
                            type: "success",
                        });
                        this.delete_confirmation_modal.loading = false;
                    });
            }
        },

        // c_modal
        c_modal_invite_member() {
            this.c_modal.loading = true;
            this.$apollo
                .mutate({
                    mutation: CREATE_ORGANIZATION_MEMBER_INVITE,
                    variables: {
                        organization_id: this.organization_id,
                        email: this.c_modal.form.email,
                    },
                })
                .then(() => {
                    this.c_modal.loading = false;

                    this.c_modal.success = true;
                    setTimeout(() => {
                        this.c_modal.success = false;
                    }, 1000);
                    setTimeout(() => {
                        this.$bvModal.hide("c_modal");
                    }, 800);
                    this.$notify({
                        message: `Invite successfully sent to: '${this.c_modal.form.email}'`,
                        timeout: 5000,
                        icon: "ni ni-check-bold",
                        type: "success",
                    });
                })
                .catch((err) => {
                    if (
                        String(err).includes("ID cannot represent value: None")
                    ) {
                        this.c_modal.success = true;
                        setTimeout(() => {
                            this.c_modal.success = false;
                        }, 1000);
                        setTimeout(() => {
                            this.$bvModal.hide("c_modal");
                        }, 800);
                        this.$notify({
                            message: `Invite successfully sent to: '${this.c_modal.form.email}'`,
                            timeout: 5000,
                            icon: "ni ni-check-bold",
                            type: "success",
                        });
                    } else {
                        console.log(err);
                    }

                    this.c_modal.loading = false;
                });
        },
    },
    watch: {
        organization_id() {
            if (this.organization_id) {
                graph_utils.enable_query(
                    this.$apollo.queries.get_organization_members
                );
            } else {
                graph_utils.disable_query(
                    this.$apollo.queries.get_organization_members
                );
            }
        },
    },
    mounted() {
        if (!this.$apollo.queries.get_organization_members.skip) {
            this.$apollo.queries.get_organization_members.refetch();
        }
    },
};
</script>

<style></style>
